import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take, first } from 'rxjs/internal/operators';

import { Holiday } from './../models/holiday';

const API_KEY = 'AIzaSyDWwhlAYMRbGEd1apbd8xW0vqG0Fl_iQwE';
const CALENDAR_ID = 'pt.brazilian%23holiday%40group.v.calendar.google.com';

@Injectable({
  providedIn: 'root'
})
export class GoogleCalendarHolidayService {

  private readonly baseUrl = `https://www.googleapis.com/calendar/v3/calendars/${CALENDAR_ID}/events`;
  constructor(private http: HttpClient) { }

  getHolidayBetweenDates(startDate: string, endDate: string): Observable<Holiday[]> {
    const timeMin = `${startDate}T00:00:00Z`;
    const timeMax = `${endDate}T23:59:59Z`;
    const query = `key=${API_KEY}&timeMin=${timeMin}&timeMax=${timeMax}&maxResults=100`;
    const url = this.getUrl(query);
    return this.http.get<any>(url).pipe(take(1), map(kind => kind?.items));
  }

  getHolidaysYear(year: string | number): Observable<Holiday[]> {
    const startDate = `${year}-01-01`;
    const endDate = `${year}-12-31`;
    return this.getHolidayBetweenDates(startDate, endDate);
  }

  getHolidayName(date: string): Observable<string> {
    return this.getHolidayBetweenDates(date, date).pipe(first(), map(holidays => holidays[0]?.summary ?? ''));
  }

  isHoliday(date: string): Observable<any> {
    return this.getHolidayName(date).pipe(map(holidayName => holidayName !== ''));
  }

  private getUrl(query: string): string {
    return `${this.baseUrl}?${query}`;
  }
}
